module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "v-fade-transition",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.settings.visible),
      callback: function($$v) {
        _vm.$set(_vm.settings, "visible", $$v)
      },
      expression: "settings.visible"
    }
  }, [_c('v-card', {
    staticClass: "show-print"
  }, [_c('v-card-title', {
    staticStyle: {
      "padding": "0"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.dialogTitle || 'Send Email'))]), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.minimise
    }
  }, [_c('v-icon', [_vm._v("remove")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('a', {
    staticClass: "transparent",
    attrs: {
      "href": ("/templates/" + (_vm.template.key)),
      "target": "_blank"
    }
  }, [_c('v-list-item', {
    on: {
      "click": function($event) {
        1
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Open this Template")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {}
    }
  }, [_c('a', {
    staticClass: "transparent",
    attrs: {
      "href": _vm.mailToLink,
      "target": "_blank"
    }
  }, [_c('v-list-item-title', [_vm._v("Send via my normal Email")])], 1)]), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.sendTestEmail
    }
  }, [_c('v-list-item-title', [_vm._v("Send a Test Email")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "max-height": "100%",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "recipient-heading"
  }, [_vm._v("To")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('ContactAutocomplete', {
    key: 1,
    attrs: {
      "items": _vm.contactsWithEmail
    },
    on: {
      "change": _vm.mergeGreeting
    },
    model: {
      value: (_vm.email.to),
      callback: function($$v) {
        _vm.$set(_vm.email, "to", $$v)
      },
      expression: "email.to"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-1 recipient-heading"
  }, [_c('div', {
    staticClass: "hoverable clickable rounded full-height pr-2 pt-1",
    class: {
      'blue-hilight': _vm.hasRecipientsCopied
    },
    on: {
      "click": function($event) {
        _vm.showCC = !_vm.showCC
      }
    }
  }, [_vm._v("\n                            CC\n                        ")])])]), _vm._v(" "), (_vm.showCC) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "recipient-heading"
  }, [_vm._v("Cc")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('ContactAutocomplete', {
    attrs: {
      "items": _vm.contactsWithEmail
    },
    model: {
      value: (_vm.email.cc),
      callback: function($$v) {
        _vm.$set(_vm.email, "cc", $$v)
      },
      expression: "email.cc"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "recipient-heading"
  }, [_vm._v("Bcc")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('ContactAutocomplete', {
    attrs: {
      "items": _vm.contactsWithEmail
    },
    model: {
      value: (_vm.email.bcc),
      callback: function($$v) {
        _vm.$set(_vm.email, "bcc", $$v)
      },
      expression: "email.bcc"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin": "0px 20px 0px 20px",
      "font-size": "14px"
    },
    attrs: {
      "label": "Subject",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.subjectChanged
    },
    model: {
      value: (_vm.email.subject),
      callback: function($$v) {
        _vm.$set(_vm.email, "subject", $$v)
      },
      expression: "email.subject"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pt-2",
    staticStyle: {
      "width": "70px"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "text": "",
            "color": "grey"
          }
        }, on), [_c('v-badge', {
          attrs: {
            "color": "grey lighten-1"
          }
        }, [_c('span', {
          attrs: {
            "slot": "badge"
          },
          slot: "badge"
        }, [_vm._v(_vm._s(_vm.templates.length))]), _vm._v(" "), _c('v-icon', [_vm._v("more")])], 1)], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.templates), function(template) {
    return _c('v-list-item', {
      key: template.key,
      on: {
        "click": function($event) {
          return _vm.selectTemplate(template)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(template.name))])], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('HtmlEditor', {
    model: {
      value: (_vm.email.body),
      callback: function($$v) {
        _vm.$set(_vm.email, "body", $$v)
      },
      expression: "email.body"
    }
  }), _vm._v(" "), (_vm.showAttachments) ? _c('div', [_c('v-combobox', {
    staticStyle: {
      "margin": "0px 20px 0px 20px"
    },
    attrs: {
      "items": _vm.files,
      "single-line": "",
      "hide-details": "",
      "label": "Attachments",
      "chips": "",
      "multiple": "",
      "return-object": "",
      "item-text": "fileName"
    },
    model: {
      value: (_vm.email.attachments),
      callback: function($$v) {
        _vm.$set(_vm.email, "attachments", $$v)
      },
      expression: "email.attachments"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', [_c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "3px",
      "flex-grow": "1"
    },
    attrs: {
      "xxxclass": "v-box clickable"
    }
  }, [(_vm.from.special) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("alternate_email")])], 1)]
      }
    }], null, false, 3468281524)
  }, [_vm._v(" "), _c('span', [_vm._v("Sending via " + _vm._s(_vm.from.email))])]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showAttachments = !_vm.showAttachments
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "grey darken-1"
          }
        }, [_vm._v("attach_file")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Attachments")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.urgent = !_vm.urgent
            }
          }
        }, on), [(_vm.urgent) ? _c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("notifications")]) : _c('v-icon', {
          attrs: {
            "color": "grey lighten-1"
          }
        }, [_vm._v("notifications")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Alert by SMS")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": _vm.print
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "grey lighten-1"
          }
        }, [_vm._v("print")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Print email")])]), _vm._v(" "), (_vm.urgent) ? _c('span', {
    staticClass: "grey--text"
  }, [_vm._v("SMS will also be sent")]) : _vm._e(), _vm._v(" "), (_vm.validationErrors) ? _c('span', {
    staticClass: "red--text",
    domProps: {
      "innerHTML": _vm._s(_vm.validationErrors)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "padding": "3px",
      "min-width": "220px"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.cancelClicked
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (this.validationErrors) ? [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": "",
            "disabled": ""
          }
        }, on), [_vm._v("Send")])]
      }
    }], null, false, 3493161756)
  }, [_vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(this.validationErrors)
    }
  })])] : [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.sendClicked
    }
  }, [_vm._v(_vm._s(_vm.sendLabel))])]], 2)])])], 1)], 1), _vm._v(" "), (_vm.settings.minimised) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "right": "0",
      "width": "300px"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.dialogTitle))]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.maximise
    }
  }, [_c('v-icon', [_vm._v("web_asset")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e08d1b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/EmailDialog.vue
// module id = 2496
// module chunks = 1